module.exports = __webpack_public_path__ + "static/media/YF84_9.f1797269.jpg";